import { NumberValue, VALUE_TYPE } from "Components/NumberValue";
import React, { ReactElement } from "react";
import {
  Message,
  PriceLabel,
  StyledTotalPrice,
  TotalPriceText,
  Wrap,
} from "./styled";

import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { useComponentTexts } from "Store/texts/hooks";

interface Props {
  readonly message?: string;
  readonly totalPriceValue?: number;
  readonly isLoading?: boolean;
  readonly sticky?: boolean;
}

export const TotalPriceMessage = ({
  message,
  totalPriceValue,
  isLoading = false,
}: Props): ReactElement => {
  const [{ totalPriceMessage }, lang] = useComponentTexts();
  return (
    <Wrap>
      <Message>{message}</Message>
      {totalPriceValue !== undefined && (
        <TotalPriceText>
          <PriceLabel>{`${totalPriceMessage.totalPrice[lang]} `}</PriceLabel>
          <StyledTotalPrice>
            {isLoading ? (
              <ThemedSpinner black />
            ) : (
              <NumberValue
                value={totalPriceValue}
                type={VALUE_TYPE.NOK}
                largeValue
              />
            )}
          </StyledTotalPrice>
        </TotalPriceText>
      )}
    </Wrap>
  );
};
